var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimpar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 7.65C2.76356 7.65 1.35 6.23644 1.35 4.5C1.35 2.76356 2.76356 1.35 4.5 1.35C6.23644 1.35 7.65 2.76356 7.65 4.5C7.65 6.23644 6.23644 7.65 4.5 7.65ZM4.5 0.5625C3.98292 0.5625 3.4709 0.664346 2.99318 0.862224C2.51546 1.0601 2.0814 1.35014 1.71577 1.71577C0.977343 2.45419 0.5625 3.45571 0.5625 4.5C0.5625 5.54429 0.977343 6.54581 1.71577 7.28423C2.0814 7.64986 2.51546 7.9399 2.99318 8.13778C3.4709 8.33566 3.98292 8.4375 4.5 8.4375C5.54429 8.4375 6.54581 8.02266 7.28423 7.28423C8.02266 6.54581 8.4375 5.54429 8.4375 4.5C8.4375 3.98292 8.33566 3.4709 8.13778 2.99318C7.9399 2.51546 7.64986 2.0814 7.28423 1.71577C6.9186 1.35014 6.48454 1.0601 6.00682 0.862224C5.5291 0.664346 5.01708 0.5625 4.5 0.5625ZM2.53125 4.89375H6.46875V4.10625H2.53125",
    fill: "#273CF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimpar);
export default __webpack_public_path__ + "static/media/limpar.621d0b691ba4e48bb5fc700a76633d7b.svg";
export { ForwardRef as ReactComponent };